import React from "react";

function NotFound(){
    return (
        <div>You came in Wrong direction. Please go <a href="/">Home</a>!</div>
    );
}
export default NotFound;